import React from 'react';
import ParticipantReviewModal from './ParticipantReviewModal';
import SessionSummaryModal from './SessionSummaryModal';
import { useEndOfCallFlow } from '../hooks/useEndOfCallFlow';

interface EndOfCallModalsProps {
  flow: ReturnType<typeof useEndOfCallFlow>;
}

/** The end-of-call sheets for a bot session: participant review (creator), then the summary. */
const EndOfCallModals: React.FC<EndOfCallModalsProps> = ({ flow }) => (
  <>
    {flow.participantReview && (
      <ParticipantReviewModal
        sessionId={flow.participantReview.sessionId}
        rows={flow.participantReview.rows}
        roster={flow.participantReview.roster}
        isCreator={flow.participantReview.isCreator}
        onDone={flow.finishParticipantReview}
      />
    )}
    {flow.sessionSummaryData && (
      <SessionSummaryModal
        isOpen={flow.showSessionSummary}
        onClose={flow.closeSummary}
        onClearSession={flow.clearSessionData}
        summary={flow.sessionSummaryData}
      />
    )}
  </>
);

export default EndOfCallModals;
